import React, { useState } from "react";
import { Card } from '@mui/material'
import { texts } from "../../general/texts";
import colors from "../../colors";
import { makeStyles } from '@mui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useNavigate } from "react-router-dom";
import { ReactComponent as NoRefIcon } from "../../../icons/no-ref-icon.svg";
import { ReactComponent as OrangeDot } from "../../../icons/OrangeDot.svg";

const NoReferences = () => {
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate()

    const useStyles = makeStyles({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        noReferencesCard: {
            display: 'flex',
            flexDirection: isSmallScreen ? 'column-reverse' : 'row',
            padding: "15px",
            width: isSmallScreen ? "90vw" : "915px",
            height: isSmallScreen ? "80vh" : "400px",
            borderRadius: "14px",
            textAlign: isSmallScreen ? "center" : "left",
            borderRadius: "15px",
            marginTop: "80px",
            '& h1': {
                marginBottom: "30px",
            },
            '& h3': {
                marginBottom: "10px",
            },
            '& h4': {
                margin: "0",
            },
            '& p': {
                margin: "0",
                marginBottom: "10px",
            }
        },
        flexRow: {
            display: 'flex',
            flexDirection: 'row',
        },

        flexCol: {
            display: 'flex',
            flexDirection: 'column',
        },

        easyPayButton: {
            color: colors.white,
            background: "linear-gradient(321.73deg, #F0A13D 26.7%, #EF7A30 98.66%)",
            border: 'none',
            borderRadius: '10px',
            width: '300px',
            height: '42px',
            fontSize: '18px',
            marginTop: '50px',
            cursor: 'pointer'
        }
    });

    const classes = useStyles();

    return (
        <>
            <div className={classes.container}>
                <Card className={classes.noReferencesCard}>
                    <div style={{ marginLeft: '15px' }}>
                        <h1 style={{ color: colors.orange }}>{texts['title-no-references']}</h1>
                        <h3 style={{ color: colors.darkBlue, fontSize: '20px' }}>{texts['info-no-ref']}</h3>
                        <div className={classes.flexRow}>
                            <OrangeDot width={20} style={{ marginTop: 10, marginRight: 10 }} />
                            <p style={{ color: colors.darkBlue, fontSize: '20px' }}>{texts['no-ref-p1']}</p>
                        </div>
                        <div className={classes.flexRow}>
                            <OrangeDot width={20} style={{ marginTop: 10, marginRight: 10 }} />
                            <p style={{ color: colors.darkBlue, fontSize: '20px' }}>{texts['no-ref-p2']}</p>
                        </div>
                        <button onClick={() => navigate('/inviteFriend')} className={classes.easyPayButton}>{texts['button-invite-friends']}</button>
                    </div>
                    <NoRefIcon width={isSmallScreen ? 400 : 506} height={280} style={{ marginTop: '80px' }} />
                </Card>
            </div>
        </>
    )
}
export default NoReferences;